import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebase/firebase";

export async function updateTOS() {
    const updateTOS = httpsCallable(functions, 'updateTOS');
    
    return updateTOS();
}

export async function acceptTOS() {
    const acceptTOS = httpsCallable(functions, 'acceptTOS');

    return acceptTOS();
}